<div class="search-page">
  <header class="page-header">
    <h1>Retiros Binance — Buscar por wallet</h1>
    <p class="subtitle">
      Consulta en vivo contra la cuenta master de Binance. Sin filtros lista
      todos los retiros USDT de los últimos 90 días (hasta hoy). Ingresá una
      wallet externa para acotar la búsqueda. Solo operadores.
    </p>
  </header>

  <form
    class="search-form"
    [formGroup]="form"
    (ngSubmit)="search(true)"
    autocomplete="off"
  >
    <div class="form-row">
      <mat-form-field appearance="outline" class="wallet-field">
        <mat-label>Wallet externa (USDT, opcional)</mat-label>
        <input
          matInput
          formControlName="walletAddress"
          placeholder="Ej: TXyz... (TRC20) o 0x... (ERC20/BEP20)"
          spellcheck="false"
          autocapitalize="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Desde</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Hasta</mat-label>
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="loading"
      >
        <mat-icon>search</mat-icon>
        {{ loading ? 'Buscando…' : 'Buscar' }}
      </button>

      <button
        mat-stroked-button
        color="accent"
        type="button"
        [disabled]="exporting"
        (click)="exportToExcel()"
      >
        <mat-icon>file_download</mat-icon>
        {{ exporting ? 'Generando Excel…' : 'Descargar Excel' }}
      </button>

      <span class="hint">
        Sin fechas: últimos 90 días. Máximo 365 días por consulta.
      </span>
    </div>
  </form>

  <div class="results" *ngIf="hasSearched && !loading">
    <div class="results-summary">
      <div>
        <strong>{{ total }}</strong> retiro(s) encontrados
        <ng-container *ngIf="walletSearched">
          para <code class="wallet-chip">{{ walletSearched }}</code>
        </ng-container>
        <ng-container *ngIf="!walletSearched">
          (sin filtro de wallet)
        </ng-container>
      </div>
      <div class="range-chip" *ngIf="rangeStart && rangeEnd">
        Rango consultado:
        {{ formatDateTime(rangeStart) }} → {{ formatDateTime(rangeEnd) }}
      </div>
    </div>

    <div class="error-box" *ngIf="errorMessage">
      <mat-icon>error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="table-wrapper" *ngIf="rows.length > 0">
      <table mat-table [dataSource]="rows" [trackBy]="trackByBinanceId">
        <ng-container matColumnDef="applyTime">
          <th mat-header-cell *matHeaderCellDef>Fecha solicitud</th>
          <td mat-cell *matCellDef="let row">
            {{ formatDateTime(row.applyTime) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="completeTime">
          <th mat-header-cell *matHeaderCellDef>Fecha completado</th>
          <td mat-cell *matCellDef="let row">
            {{ formatDateTime(row.completeTime) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Monto</th>
          <td mat-cell *matCellDef="let row" class="numeric">
            {{ row.amount | number: '1.2-8' }} USDT
          </td>
        </ng-container>

        <ng-container matColumnDef="fee">
          <th mat-header-cell *matHeaderCellDef>Fee</th>
          <td mat-cell *matCellDef="let row" class="numeric">
            {{ row.transactionFee | number: '1.2-8' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="network">
          <th mat-header-cell *matHeaderCellDef>Red</th>
          <td mat-cell *matCellDef="let row">{{ row.network }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let row">
            <span [class]="statusBadgeClass(row.status)">
              {{ row.statusText }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.localUser; else noUser">
              <div class="user-cell">
                <span class="user-name">{{ row.localUser.userName || '—' }}</span>
                <span class="user-email">{{ row.localUser.userEmail }}</span>
                <span class="user-id">ID: {{ row.localUser.userId }}</span>
                <span
                  class="source-tag"
                  [class.source-binance]="row.localUser.source === 'binance_withdrawal'"
                  [class.source-cripto]="row.localUser.source === 'transaccion_cripto'"
                  [matTooltip]="sourceTooltip(row.localUser.source)"
                >
                  {{ sourceLabel(row.localUser.source) }}
                </span>
                <span
                  *ngIf="row.localUser.walletMatches === false"
                  class="wallet-mismatch"
                  matTooltip="La wallet registrada en nuestra DB para este retiro NO coincide con la dirección que Binance reporta"
                >
                  <mat-icon>warning</mat-icon> wallet mismatch
                </span>
              </div>
            </ng-container>
            <ng-template #noUser>
              <span class="muted">— (origen externo)</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="rail">
          <th mat-header-cell *matHeaderCellDef>Rail</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.localUser; else noRail">
              <span class="rail-chip">{{ row.localUser.rail }}</span>
            </ng-container>
            <ng-template #noRail>
              <span class="muted">—</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="txId">
          <th mat-header-cell *matHeaderCellDef>TxId</th>
          <td mat-cell *matCellDef="let row" class="mono">
            <span [matTooltip]="row.txId || ''">
              {{ shortTxId(row.txId) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Wallet destino</th>
          <td mat-cell *matCellDef="let row" class="mono">
            <span [matTooltip]="row.address">{{ shortTxId(row.address) }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <mat-paginator
      *ngIf="rows.length > 0"
      [length]="total"
      [pageSize]="limit"
      [pageIndex]="page - 1"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
      showFirstLastButtons
    ></mat-paginator>

    <div class="empty-state" *ngIf="rows.length === 0">
      <mat-icon>inbox</mat-icon>
      <p>
        No se encontraron retiros para esa wallet en el rango consultado.
      </p>
    </div>
  </div>

  <div class="loading-state" *ngIf="loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Consultando Binance…</span>
  </div>
</div>
